/**
 * VAST TRADES - Theme JavaScript
 * Mobile menu, cart drawer, quick view, product tabs, quantity inputs
 */

document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initCartDrawer();
  initProductTabs();
  initQuantityInputs();
  initNavigationMegaMenu();
  initStickyHeader();
  initCartItemRemoval();
  initEmailPopup();
  initProductForm();
});

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const toggleBtns = document.querySelectorAll('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');

  if (!mobileMenu) return;

  function open() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggleBtns.forEach(btn => btn.addEventListener('click', open));
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      close();
    }
  });
}

/**
 * Cart Drawer
 */
function initCartDrawer() {
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartContent = document.querySelector('[data-cart-drawer-content]');

  if (!cartDrawer) return;

  function open() {
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function close() {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', (e) => { e.preventDefault(); open(); });
  if (cartClose) cartClose.addEventListener('click', close);
  if (cartOverlay) cartOverlay.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
      close();
    }
  });

  async function fetchCart() {
    if (!cartContent) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCartDrawer(cart);
    } catch (err) {
      cartContent.innerHTML = '<p class="cart-drawer__error">Unable to load cart.</p>';
    }
  }

  function renderCartDrawer(cart) {
    if (cart.item_count === 0) {
      cartContent.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-items__empty-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
          </div>
          <p style="text-align:center;color:var(--color-text-secondary);">Your cart is empty.</p>
          <a href="/collections/all" class="button button--gold" style="display:block;text-align:center;margin-top:1rem;">Browse Equipment</a>
        </div>
      `;
      return;
    }

    let html = '<div class="cart-drawer__items">';
    cart.items.forEach(item => {
      html += `
        <div class="cart-drawer__item" data-item-key="${item.key}">
          <div class="cart-drawer__item-image">
            <img src="${item.image}" alt="${item.title}" width="80" height="80" style="width:80px;height:80px;object-fit:contain;border-radius:var(--radius-sm);background:var(--color-surface);border:1px solid var(--color-border);">
          </div>
          <div class="cart-drawer__item-details">
            <a href="${item.url}" class="cart-drawer__item-title" style="font-weight:500;color:var(--color-text);font-size:0.9375rem;">${item.title}</a>
            <span class="cart-drawer__item-price" style="font-family:var(--font-heading);font-style:italic;color:var(--color-primary);font-size:1rem;">${formatMoney(item.final_line_price)}</span>
          </div>
          <button type="button" class="cart-drawer__item-remove" data-remove-drawer data-key="${item.key}" style="color:var(--color-text-muted);padding:0.5rem;" aria-label="Remove item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
      `;
    });
    html += '</div>';
    html += `
      <div class="cart-drawer__footer" style="margin-top:1.5rem;padding-top:1.5rem;border-top:1px solid var(--color-border);">
        <div style="display:flex;justify-content:space-between;margin-bottom:1rem;">
          <span style="font-weight:600;">Subtotal</span>
          <span style="font-family:var(--font-heading);font-style:italic;color:var(--color-primary);font-size:1.25rem;font-weight:700;">${formatMoney(cart.original_total_price)}</span>
        </div>
        <a href="/cart" class="button button--gold button--full" style="margin-bottom:0.5rem;">View Cart</a>
        <a href="/checkout" class="button button--outline-gold button--full">Checkout</a>
      </div>
    `;
    cartContent.innerHTML = html;

    // Attach remove handlers
    cartContent.querySelectorAll('[data-remove-drawer]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          fetchCart();
          updateCartCount();
        } catch (e) {
          console.error('Cart update failed', e);
        }
      });
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }
}

/**
 * Update cart count badge
 */
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.querySelector('.header__cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
}

/**
 * Product Tabs (Description / Specs / Shipping)
 */
function initProductTabs() {
  const tabContainer = document.querySelector('.product-specs__tabs');
  if (!tabContainer) return;

  const tabs = tabContainer.querySelectorAll('.product-specs__tab');
  const panels = document.querySelectorAll('.product-specs__panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('product-specs__tab--active'));
      tab.classList.add('product-specs__tab--active');

      panels.forEach(p => {
        p.classList.toggle('product-specs__panel--active', p.dataset.panel === target);
      });
    });
  });
}

/**
 * Quantity Inputs (+/- buttons)
 */
function initQuantityInputs() {
  document.querySelectorAll('quantity-input').forEach(wrapper => {
    const input = wrapper.querySelector('input[type="number"]');
    const minusBtn = wrapper.querySelector('[data-quantity-minus]');
    const plusBtn = wrapper.querySelector('[data-quantity-plus]');

    if (!input) return;

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        const max = parseInt(input.max, 10);
        if (!max || val < max) {
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}

/**
 * Navigation Mega Menu (click outside to close on mobile)
 */
function initNavigationMegaMenu() {
  // Desktop hover already handled via CSS
  // This ensures mobile tap doesn't get stuck
  if (window.matchMedia('(pointer: coarse)').matches) {
    document.querySelectorAll('.navigation__item').forEach(item => {
      item.addEventListener('click', (e) => {
        const megaMenu = item.querySelector('.mega-menu');
        if (megaMenu && !e.target.closest('.mega-menu a')) {
          e.preventDefault();
          const isOpen = item.classList.contains('is-open');
          document.querySelectorAll('.navigation__item').forEach(i => i.classList.remove('is-open'));
          if (!isOpen) item.classList.add('is-open');
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.navigation__item')) {
        document.querySelectorAll('.navigation__item').forEach(i => i.classList.remove('is-open'));
      }
    });
  }
}

/**
 * Sticky Header shadow on scroll
 */
function initStickyHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (window.scrollY > 10) {
          header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.3)';
        } else {
          header.style.boxShadow = 'none';
        }
        ticking = false;
      });
      ticking = true;
    }
  });
}

/**
 * Cart item removal (inline on cart page)
 */
function initCartItemRemoval() {
  document.querySelectorAll('[data-remove]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const index = btn.dataset.index;
      const form = document.getElementById('cart-form');
      if (!form) return;

      const input = form.querySelector(`input[name="updates[]"][data-index="${index}"]`);
      if (input) {
        input.value = 0;
        form.submit();
      }
    });
  });
}

/**
 * Email capture popup
 */
function initEmailPopup() {
  const popup = document.querySelector('[data-email-popup]');
  if (!popup) return;

  const overlay = popup.querySelector('.email-popup__overlay');
  const closeButtons = popup.querySelectorAll('[data-email-popup-close]');
  const form = popup.querySelector('form');
  const hasSuccessMessage = popup.querySelector('.email-popup__status--success');
  const hasErrorMessage = popup.querySelector('.email-popup__status--error');
  const dismissedKey = 'vtEmailPopupDismissed';
  const subscribedKey = 'vtEmailPopupSubscribed';

  function open() {
    popup.hidden = false;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('email-popup-open');
  }

  function close({ rememberDismissal = true } = {}) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('email-popup-open');
    window.setTimeout(() => {
      if (!popup.classList.contains('is-open')) {
        popup.hidden = true;
      }
    }, 180);

    if (rememberDismissal) {
      localStorage.setItem(dismissedKey, 'true');
    }
  }

  if (overlay) {
    overlay.addEventListener('click', () => close());
  }

  closeButtons.forEach(button => {
    button.addEventListener('click', () => close());
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      close();
    }
  });

  if (form) {
    form.addEventListener('submit', () => {
      localStorage.setItem(subscribedKey, 'true');
      localStorage.setItem(dismissedKey, 'true');
    });
  }

  if (hasSuccessMessage) {
    localStorage.setItem(subscribedKey, 'true');
    open();
    return;
  }

  if (hasErrorMessage) {
    open();
    return;
  }

  if (localStorage.getItem(dismissedKey) || localStorage.getItem(subscribedKey)) {
    return;
  }

  // Do not auto-open the popup on mobile (it covered the whole screen); delay to 30s on desktop.
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
    return;
  }

  window.setTimeout(() => {
    if (!localStorage.getItem(dismissedKey) && !localStorage.getItem(subscribedKey)) {
      open();
    }
  }, 30000);
}

/**
 * AJAX Add to Cart
 * Fixes the broken add-to-cart: the <product-form> element was never defined in JS,
 * so the product form did a full-page POST to /cart/add that landed on Shopify's
 * "There was a problem loading this website" error page (even though the item was
 * added). This intercepts the submit, adds via /cart/add.js, and opens the cart drawer.
 */
function initProductForm() {
  var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      var btn = form.querySelector('[name="add"]');
      var textEl = form.querySelector('[data-add-to-cart-text]');
      var originalText = textEl ? textEl.textContent : '';

      if (btn) btn.setAttribute('disabled', 'disabled');
      if (textEl) textEl.textContent = 'Adding…';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });

        if (!res.ok) {
          var msg = 'This item could not be added to your cart.';
          try {
            var errJson = await res.json();
            if (errJson && errJson.description) msg = errJson.description;
          } catch (parseErr) {}
          throw new Error(msg);
        }

        await res.json();
        updateCartCount();

        // Open the cart drawer (its toggle handles drawer-open + cart fetch).
        // If there is no drawer on the page, the toggle is a plain link to /cart.
        var cartToggle = document.querySelector('[data-cart-toggle]');
        var cartDrawer = document.getElementById('cart-drawer');
        if (cartToggle && cartDrawer) {
          cartToggle.click();
        } else {
          window.location.href = '/cart';
          return;
        }

        if (textEl) textEl.textContent = 'Added ✓';
        window.setTimeout(function () {
          if (textEl) textEl.textContent = originalText;
        }, 1600);
      } catch (err) {
        if (textEl) textEl.textContent = originalText;
        window.alert((err && err.message) || 'This item could not be added to your cart. Please try again.');
      } finally {
        if (btn) btn.removeAttribute('disabled');
      }
    });
  });
}

/**
 * Quick View (placeholder - can be extended)
 */
function initQuickView() {
  const modal = document.getElementById('quick-view-modal');
  const overlay = document.querySelector('[data-quick-view-overlay]');

  if (!modal) return;

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      close();
    }
  });
}

// ??? Shopify AJAX Cart Helpers ???

if (typeof window.Shopify === 'undefined') window.Shopify = {};

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) return '0';

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};
